import { Component, ViewChild, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../../_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { Observable } from 'rxjs/observable';
import { saveAs } from 'file-saver';

declare var $: any;

@Component({
	selector: 'app-combbined-report',
	templateUrl: './combbined-report.component.html',
	styleUrls: ['./combbined-report.component.scss']
})
export class CombbinedReportComponent {
	@ViewChild('table') table: ElementRef;
	public prjId: any;
	public userId: any;
	public startDate: any;
	public endDate: any;
	public defaultStartDate: any;
	public defaultEndDate: any;
	public dataRangeModal: any;
	public showLoader: boolean;
	public disFuelReport: any;
	public vtsDataNotFound = false;
	public search: any;
	syncing: any;
	public selectedRow: Number;
	loaderClass: any;
	reportDate: any;
	vehicleList: any[];
	getReport: any;
	pageSize = 25;
	page = 4;
	constructor(
		private http: HttpClient,
		private auth: AuthService,
		public routes: ActivatedRoute,
		public router: Router,
		private loaderService: LoaderService
	) {
		this.loaderService.status.subscribe((val: boolean) => {
			this.showLoader = val;
		});
		var date = new Date();
		this.defaultStartDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.defaultEndDate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
		this.dataRangeModal = {
			beginDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() },
			endDate: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() }
		};
	}

	/*
    * Get VEHICLE HISTORY DEATILS 
    */
	getVtsDailyReport() {
		this.loaderService.display(true);
		this.http
			.get(
				environment.apiUrl +
				'reports/getDistanceFuelTonnageReport?prjId=' +
				this.prjId +
				'&startDate=' +
				this.startDate +
				'&endDate=' +
				this.endDate
			)
			.subscribe(
				(data) => {
					this.disFuelReport = data;
					console.log(this.disFuelReport);
					this.getReportDate(this.disFuelReport);
					this.getReport = this.disFuelReport.distinctVehicles;
					console.log('Report', this.getReport);
					if (this.disFuelReport.length > 0) {
						this.loaderService.display(false);
						this.vtsDataNotFound = true;
					} else {
						this.loaderService.display(false);
						this.vtsDataNotFound = false;
					}
				},
				(error) => {
					this.loaderService.display(false);
					Swal({
						type: 'error',
						title: 'Oops...',
						text: 'An Error Occurred Please Try Again'
					});
				}
			);
	}

	getReportDate(date) {
		this.reportDate = date.dates;
		console.log('Dates', this.reportDate);
	}

	/*
    *select start Date Nad To date
    */
	onDateRangeChanged(dataRange) {
		if (dataRange.beginDate.day > 0) {
			this.startDate = dataRange.beginDate.year + '-' + dataRange.beginDate.month + '-' + dataRange.beginDate.day;
			this.endDate = dataRange.endDate.year + '-' + dataRange.endDate.month + '-' + dataRange.endDate.day;
			this.getVtsDailyReport();
		} else if (dataRange.beginDate.day == 0) {
			this.startDate = this.defaultStartDate;
			this.endDate = this.defaultEndDate;
			this.getVtsDailyReport();
		}
	}

	syncData() {
		this.syncing = true;
		this.loaderClass = 'fas fa-sync fa-spin';
		this.http
			.get(environment.apiUrl + 'reports/getDistanceFuelReport?prjId=' + this.prjId + '&date=' + this.startDate)
			.subscribe((data) => {
				// this.fuelReportList = data;
				this.syncing = false;
				this.loaderClass = 'fas fa-sync';
				this.getVtsDailyReport();
			});
	}

	/*
    * This Method Is use to Download the Vehicles Report into Excel File 
    */

	importVtsDailyReport() {
		const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
		const wb: XLSX.WorkBook = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

		/* save to file */
		XLSX.writeFile(wb, 'DistanceFuelReport.xlsx');
	}

	/*
     * Get Index and Select Table Row
     */
	selectRowIndex(data, index) {
		this.selectedRow = index;
	}

	ngOnInit() {
		this.prjId = this.auth.getAuthentication().projectId;
		this.userId = this.auth.getAuthentication().id;
		this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
		this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
		this.getVtsDailyReport();
		this.syncing = false;
		this.loaderClass = 'fas fa-sync';
	}
}



// WEBPACK FOOTER //
// ./src/app/reports/cost-control/combbined-report/combbined-report.component.ts